import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let CriteriaEditor;

class Criteria_editor extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: CriteriaEditor };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/crux-components/criteria-editor" */
      "../../../components/javascript/crux-components/criteria-editor"
    ).then(function(res) {
      CriteriaEditor = res.CriteriaEditor;
    }));

    
;
  }
}

export { Criteria_editor };
